<template>
  <div
    :class="{
      mobile: isPayment,
      desktop: !isPayment,
      guiding: isGuiding(),
    }"
  >
    <template v-if="isPayment">
      <div v-if="signedIn" id="container">
        <section class="header-payment">
          <!-- <div id="header-title"></div> -->
          <img src="@/assets/sp_logo.svg" />
        </section>
        <div id="main">
          <router-view/>
        </div>
      </div>
      <RiceLogAuthenticator v-else :authConfig="authConfig" />
    </template>
    <template v-else>
      <div id="container" v-if="signedIn">
        <section v-if="isMobileAny()" id="header">
          <a href="#" id="humberger-menu" @click="expandMenu = !expandMenu"></a>
          <div id="header-title"></div>
          <img src="@/assets/sp_logo.svg" />
        </section>
        <SideMenu
          :expand="expandMenu"
          :guidePhase="guidePhase"
          @clickMenuBackground="expandMenu = !expandMenu"
          @reloadMenu="onReloadMenu"
        />
        <div id="main">
          <Map :mapVisible="showMap" @mapMounted="onShowGuide">
            <router-view
              @showMap="onShowMap"
              @hideMap="onHideMap"
              @showModal="showModal"
              @hideMenu="expandMenu = false"
              :key="reloadCounter"
            />
          </Map>
        </div>
        <div v-if="isGuiding" class="guide-backdrop"></div>
      </div>
      <RiceLogAuthenticator v-else :authConfig="authConfig" />
    </template>
    <!-- <div class="authenticator" v-else>
      <amplify-authenticator :authConfig="authConfig" />
    </div> -->
    <div id="loading">
      <img src="./assets/puff.svg" />
    </div>
    <Modal
      v-if="modal.display"
      :message="modal.message"
      :type="modal.type"
      :callbackOk="modal.callbackOk"
      :callbackCancel="modal.callbackCancel"
      :backdrop="modal.backdrop"
      @finishDialog="hideModal"
    >
    </Modal>
  </div>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import { Auth } from "aws-amplify";
import { mapActions, mapGetters } from "vuex";

import { GUIDE_PHASE, DIALOG_TYPE } from "@/constants/constants";
import isMobile from "@/mixins/ismobile";
import Dialog from "@/mixins/dialog";
import Loader from "@/mixins/loader";

import SideMenu from "@/components/menu/SideMenu";
import Map from "@/views/Map";
import Modal from "@/components/Modal";
import RiceLogAuthenticator from "@/components/authenticator/Authenticator";
// import MobilePayment from "@/views/MobilePayment";

import "sanitize.css";

export default {
  components: {
    SideMenu,
    Map,
    Modal,
    RiceLogAuthenticator,
    // MobilePayment,
  },

  mixins: [isMobile, Dialog, Loader],

  data() {
    return {
      authConfig: {
        signInConfig: {
          isSignUpDisplayed: false,
        },
      },
      signedIn: false,
      showMap: false,
      expandMenu: false,
      guidePhase: null,
      guideStack: [],
      modal: {
        display: false,
        type: DIALOG_TYPE.MESSAGE,
        backdrop: true,
        message: null,
        callbackOk: null,
        callbackCancel: null,
      },
      reloadCounter:1,
    };
  },

  computed: {
    isPayment() {
      return this.isMobilePayment();
    },
  },

  async beforeCreate() {
    // ログイン状態識別
    try {
      await Auth.currentAuthenticatedUser();
      this.signedIn = true;
    } catch (err) {
      this.signedIn = false;
    }

    AmplifyEventBus.$on("authState", (info) => {
      if (info === "signedIn") {
        this.signedIn = true;
      } else {
        this.signedIn = false;
      }
    });
  },

  methods: {
    ...mapActions(["retrievePaddyFields"]),
    ...mapGetters(["getHomeMarker", "getPaddyFields"]),

    onShowMap() {
      this.showMap = true;
    },

    onHideMap() {
      this.showMap = false;
    },

    async onShowGuide() {
      await this.decideGuide();
      this.nextGuide();
    },

    nextGuide() {
      let func = this.guideStack.shift();
      func();
    },

    async decideGuide() {
      // ホーム位置未設定の場合はまずホーム位置の設定を促す
      if (this.getHomeMarker() === null) {
        this.guideStack.push(this.guideHomeMarker);
      }

      // 田圃の登録がない場合に田圃登録を促す
      await this.loading(async () => {
        try {
          await this.retrievePaddyFields();
        } catch (error) {
          console.log(error);
        }
      });
      let paddyFields = this.getPaddyFields() || [];
      if (paddyFields.length === 0) {
        this.guideStack.push(this.guidePaddyField);
      }

      // 作業項目
      // ログイン後初回ガイドの際のみ表示する（念の為ホーム位置有無も追加で判定）
      if (!localStorage.guidedFirstTime && this.getHomeMarker() !== null) {
        this.guideStack.push(this.guideWork);
      }

      this.guideStack.push(this.finishGuide);
    },

    guideHomeMarker() {
      this.guidePhase = GUIDE_PHASE.GUIDE_ADD_HOME_MARKER;
      const msg = `初めに地図の中心を設定してください。
        地図の中心を基準に天気の情報は日々記録されます。
        メニューの [設定] → [ホーム位置] から登録できます。`;
      this.showModal(msg, DIALOG_TYPE.MESSAGE, this.nextGuide, null, {
        backdrop: false,
      });
    },

    guidePaddyField() {
      this.guidePhase = GUIDE_PHASE.GUIDE_PADDY_FIELD_ADD;
      const msg = `ほ場は
        メニューの [設定] → [ほ場] → [登録] から
        登録できます。`;
      this.showModal(msg, DIALOG_TYPE.MESSAGE, this.nextGuide, null, {
        backdrop: false,
      });
    },

    async guideWork() {
      this.guidePhase = GUIDE_PHASE.GUIDE_WORKITEM_EDIT;
      const msg = `ほ場に記録する作業項目は
          メニューの [設定] → [作業項目] からカスタマイズできます。`;
      this.showModal(msg, DIALOG_TYPE.MESSAGE, this.nextGuide, null, {
        backdrop: false,
      });

      // 初回ガイド表示済みフラグをlocalstorageに保存
      localStorage.guidedFirstTime = true;
    },

    finishGuide() {
      this.guidePhase = GUIDE_PHASE.GUIDE_FINISHED;
      // ホーム位置未設定の場合は画面遷移
      if (this.getHomeMarker() === null) {
        this.$router.push({ name: "markers" });
      }
    },

    showModal(message, type, onOk, onCancel, options) {
      this.modal.message = message;
      this.modal.type = type;
      this.modal.callbackOk = onOk;
      this.modal.callbackCancel = onCancel;
      if (options) {
        this.modal.backdrop = options.backdrop ? options.backdrop : false;
      }
      this.modal.display = true;
    },

    hideModal() {
      this.modal.display = false;
      this.modal.backdrop = true;
      this.modal.message = null;
      this.modal.callbackOk = null;
      this.modal.callbackCancel = null;
    },

    isGuiding() {
      return (
        this.guidePhase != null && this.guidePhase != GUIDE_PHASE.GUIDE_FINISHED
      );
    },

    onReloadMenu(){
      this.reloadCounter++;
    }
  },
};
</script>

<style lang="scss">
// @import "./constants/constants.scss";

// #app {
//   font-family: "Avenir", Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
//   color: #2c3e50;
// }

:root {
  // TODO purple -> theme
  --purple: #316409;
  --purple-secondary: #94b34a;
  --purple-tertiary: #ddf1ac;
  --col1: #e23333;
  --col2: #6bac3e;
  --col3: #1a82b7;
  --col4: #ea8123;
  --col5: #ffd000;
}

.purple {
  color: #9f71fc;
}
.purple-secondary {
  color: #ccb3fd;
}

@font-face {
  font-family: "Monda";
  src: url("~@/assets/font/Monda-Regular.ttf");
}

html {
  height: 100%;
  font-size: 16px;
}

body {
  background: rgb(240, 243, 245);
  /* background: red; */
  height: 100%;
  font-size: 1rem;
  font-family: "Helvetica Neue", Arial, "Hiragino Kaku Gothic ProN",
    "Hiragino Sans", Meiryo, sans-serif;
}

#container {
  margin: 0;
  padding: 0;
  width: 100vw;
  height: 100vh;
  border: none;
  display: grid;
  grid-template-columns: 250px auto;
  box-sizing: border-box;

  .mobile & {
    display: block;
    background: white;
  }
}

// TODO ここと下の@keyframesの定義位置は後ほど再考
#input,
#browse,
#water,
#weather,
#archive,
#sensor {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  /* transform: scale(0.5); */
  animation: scaleanim 0.2s ease-out;
  span {
    padding: 10px 20px;
    font-size: 30px;
    color: #fff;
    background: var(--purple);
    border-radius: 10px;
  }
}

@keyframes scaleanim {
  0% {
    transform: scale(0.5);
  }
  100% {
    transform: scale(1);
  }
}

#loading {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: none;
  justify-content: center;
  align-items: center;

  .mobile & {
    width: 100vw;
  }
}

#main {
  height: 100vh;
  overflow-y: scroll;

  .mobile & {
    height: unset;
  }
}

input + .legend {
  margin: 0.25rem 0 0 1rem;
  font-size: 0.8rem;
}

.error-message {
  margin-bottom: 1rem;
  padding: 0.75rem;
  border: 1px solid #f5c6cb;
  background: #f8d7da;
  color: #721c24;
}

.information-message {
  margin-bottom: 1rem;
  padding: 0.75rem;
  border: 1px solid #94b34a;
  background: #ddf1ac;
  color: #316409;
}

#header {
  display: grid;
  grid-template-columns: 60px 1fr 120px;
  align-items: center;
  justify-content: space-around;
  background: rgba(0, 0, 0, 0.75);
  width: 100%;
  height: 48px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20;

  a {
    display: block;
    width: 60px;
    height: 48px;
    background: url("~@/assets/icons/ic_menu.svg") no-repeat center center;
    background-size: 24px auto;
  }

  #header-title {
    color: #fff;
    text-align: left;
    font-size: 0.9rem;
    line-height: 1;
  }

  img {
    width: 100px;
  }
}
.header-payment {
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  justify-content: space-around;
  background: rgba(0, 0, 0, 0.75);
  width: 100%;
  height: 48px;
  // position: fixed;
  top: 0;
  left: 0;
  z-index: 20;

  img {
    width: 100px;
    margin-left: 20px;
  }
}

// GoogleMapのInfoWindowのcloseを消す
.gm-style-iw button.gm-ui-hover-effect {
  display: none !important;
}

// 初回ナビゲーション
.desktop.guiding {
  .guide-backdrop {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 100;
  }
}

// バリデーションのエラーメッセージ
.validation-error {
  width: 100%;
  color: var(--col1);
  font-size: 0.8rem;
  padding-left: 0.5rem;
  padding-top: 0.5rem;

  &.legend {
    padding: 0;
  }
}
</style>
